import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommLandmarkList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMobileCommLandmark: DataSource;
    tableMobileCommLandmark: Table;
}
